<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Consumable/PlanApply'">
          <el-button type="primary" size="mini">发起采购计划表审批</el-button>
        </router-link>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:300px;" v-model="filterKey" size="small"
        placeholder="你可以搜索采购员姓名/所属部门等"></el-input>

    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="0">申请中</el-radio-button>
        <el-radio-button label="1">已通过审批</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="department.name" label="所属部门">
      </el-table-column>
      <el-table-column label="采购员" width="140">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="140">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.flow.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column prop="total" width="150" label="物品总价" align="center">
      </el-table-column>
      <el-table-column label="审批状态" width="100">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)" type="primary">详情</el-button>

          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id && scope.row.flow.status!='审批通过'">
            <span
              v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消')">
              <el-tooltip class="item" effect="dark" content="修改物品申购单" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId, scope.row.projectId)"></i>
              </el-tooltip>
            </span>
            <el-tooltip v-if="scope.row.flow.status == '进行中'" class="item" effect="dark" content="取消物品申购计划"
              placement="bottom">
              <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="cancelFlow(scope.row.flow)"></i>
            </el-tooltip>
          </span>
          <!-- <el-button v-if="scope.row.flow.status=='进行中' && scope.row.flow.creator.id == userData.id " type="warning"
            plain size="mini" @click="cancelSealFlow(scope.row)">取消</el-button> -->
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>


    <!-- 取消流程弹窗 -->
    <div class="pop-room" v-if="cancleStatus">
      <a href="javascript:;" @click="cancleStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="取消原因：">
              <el-input size="small" v-model="form.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="请输入取消审批的原因"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="cancelFlowSubmit()" class="form-btn" type="success">确认取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  import ApprovalStatus from '@/components/ApprovalStatus'

  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],

        form: {
          depId: '',
          type: 0
        },
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        // filter
        filterKey: "",

        cancleStatus: "",
      }
    },
    created() {
      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      })

      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.form.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        this.form.depId = 0
      }
    },
    mounted() {},
    methods: {
      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: '/Consumable/PlanApply',
          query: {
            applyId: applyId,
          }
        })
      },
      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post('/gc/project/flow/cancel', this.form, (res) => {
          this.$message.success("取消审批成功")
          this.$store.commit('set_projectReload', true)
          this.cancleStatus = false
          this.getLists()
        })
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id
        this.cancleStatus = true
      },

      // 显示审批表详情
      projectDetail(row) {
        // console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          // 强行吧tableType变成61 也就是易耗品采购计划
          tableType: '61',
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      getDateByTime(time) {
        // return time
        return window.util.getFormatDate(time, true)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        // console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || (_item
                .type && _item.type
                .toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1)) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.filterKey = ""
        this.loading = true
        let _url = '/consumable/plan/list'

        ajax.get(_url, {
          'depId': this.form.depId == 0 ? "" : this.form.depId,
          'type': this.form.type
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.getLists()
      },
      'form.type'() {
        this.getLists()
      },
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/PlanApplyList.vue